import { useEffect, useState } from 'react';

type AutosaveStatus = 'idle' | 'saving' | 'saved';

// Global state for autosave status
let currentStatus: AutosaveStatus = 'idle';
const listeners = new Set<(status: AutosaveStatus) => void>();
let idleTimeout: ReturnType<typeof setTimeout> | null = null;

export const autosaveStatusEmitter = {
  setSaving: () => {
    clearIdleTimeout();
    notify('saving');
  },
  setSaved: () => {
    clearIdleTimeout();
    notify('saved');
    idleTimeout = setTimeout(() => {
      notify('idle');
      idleTimeout = null;
    }, 2000);
  },
  setIdle: () => {
    clearIdleTimeout();
    notify('idle');
  },
};

function clearIdleTimeout() {
  if (idleTimeout) {
    clearTimeout(idleTimeout);
    idleTimeout = null;
  }
}

function notify(status: AutosaveStatus) {
  currentStatus = status;
  listeners.forEach((listener) => {
    listener(status);
  });
}

/**
 * Hook to track autosave status.
 * Returns the current autosave status.
 */
export function useAutosaveStatus(): AutosaveStatus {
  const [status, setStatus] = useState<AutosaveStatus>(currentStatus);

  useEffect(() => {
    listeners.add(setStatus);
    return () => {
      listeners.delete(setStatus);
    };
  }, []);

  return status;
}
